var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.tours),function(tour){return [_c('tour-list-tile',{key:tour.id,attrs:{"tour":tour}}),_c('v-divider',{key:'divider-' + tour.id})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }